export default __webpack_public_path__ + "static/media/49k.4abe8162.md";